// utilities/reportCaseStatus.js

function toNumber(v) {
    const n = Number(v)
    return Number.isFinite(n) ? n : 0
}

export function deriveReportCaseStatus(currentStatus, ctx) {
    const {
        workflowCompleted,
        personInCharge,
        sentToClientDate,
        signedReceivedDate,
        totalOutstanding
    } = ctx || {}

    // 1) Closed → when workflowCompleted = true
    if (workflowCompleted === true) {
        return 'closed'
    }

    const hasPic = !!(personInCharge && String(personInCharge).trim())
    const hasSent = !!sentToClientDate
    const hasSigned = !!signedReceivedDate
    const outstanding = toNumber(totalOutstanding)

    // 2) Pending Release → signed received + outstanding = 0
    if (hasSigned && outstanding === 0) {
        return 'pending_release'
    }

    // 3) Pending Payment → signed documents received
    if (hasSigned) {
        return 'pending_payment'
    }

    // 4) Pending Doc Rec → sent to client date entered
    if (hasSent) {
        return 'pending_doc_rec'
    }

    // 5) Pending Doc Sent → PIC assigned
    if (hasPic) {
        return 'pending_doc_sent'
    }

    // 6) Default → brand new case
    return currentStatus || 'pending_assign'
}